export default __webpack_public_path__ + "static/media/razer-zsilver.b5991fb4.svg";